import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-87" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-88" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-89" data-mp="4njnu5x67n8v">
          SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontFamily: "Montserrat, sans-serif"
      }} data-id="element-90" data-mp="s9zzhikkb8n9">
          MASTER EVERY CLINICAL CONSULTATION WITH CONFIDENCE AND PROFESSIONALISM
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px",
        fontWeight: "700",
        textAlign: "center"
      }} data-id="element-91" data-mp="381xkux4z309n">
          GO FROM SPENDING HOURS PREPARING CONSULTATIONS TO HAVING THEM READY IN JUST 10 MINUTES.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-92" data-mp="399jnrenosh6n">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-93" data-mp="359t0vm1a6l7e" />
          <img src="https://cdn.magicpatterns.com/uploads/kLj3daEqiZZFimTxEjCe8Q/ChatGPT_Image_12_sept_2026,_12_38_09.png" alt="Nutrition professional holding The Nutritionist's Vault — the complete clinical nutrition system" width={1500} height={1000} className="animate-floaty mx-auto aspect-[3/2] w-full max-w-full rounded-2xl object-cover" data-id="element-94" data-mp="2qlocq2jglhh8" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px"
      }} data-id="element-95" data-mp="s333380kgeuw">
          ⭐ 4.9 (500+ satisfied dietitians and nutrition professionals) · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-96" data-mp="db2fjhflgjob">
          <CTAButton href="#value" data-id="element-97" data-mp="1azuhp455y5sm">See the Vault system now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-98" data-mp="161ayhbhyf83y">
            COMPLETE NUTRITION PRACTICE COMBO 2026. The #1 system for registered dietitians,
            nutritionists, health coaches and students who need a real, organized and ready-to-use
            professional protocol.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-99" data-mp="3ltqddexn6zuk">
            Clinical · Assessment · Meal Planning · Psychology · Supplements · Scaling
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-100" data-mp="269hegalb7f5x">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" style={{
            width: "152px",
            height: "39px"
          }} data-id="element-101" data-mp="2b20pp0wixy7k">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-102" data-mp="2l0q9iz7zdsqg" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-103" data-mp="2tzbpqnpzcvo2">
            Ebook + 5 bonuses · 120+ pages - Everything you need in one place.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-104" data-mp="uokepqlqxx7u">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-105" data-mp="4dgxquwvzn84">
              <Icon className="h-4 w-4 text-grape" data-id="element-106" data-mp="3vgvwyrmxhf5q" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-107" data-mp="e91vgguxa1c2">
          🔥 Limited-time offer · Then the price goes back up to $38 USD
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-108" data-mp="3mollz847l5nf">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-109" data-mp="2yxy908ffrpu0" />
          5 people are watching this product right now
        </p>
      </div>
    </header>;
}